import * as z from "zod";

/**
 * One row of the POS "Manage a return" screen. Display strings and gating
 * flags are computed server-side; the client only attaches interactivity.
 */
const posManageReturnsViewItemSchema = z.object({
  /** The return's Mongo id, as a string, for process/reset calls. */
  returnId: z.string(),
  /** List-row title, e.g. `Return #<id>`. */
  listLabel: z.string(),
  /** List-row subtitle lines (order/customer, products, variants). */
  listSubtitle: z.tuple([z.string(), z.string(), z.string()]),
  /** Raw ISO created timestamp, formatted on-device in the store timezone. */
  createdAtISO: z.string(),
  /** Right-aligned list-row status ("deleted" surfaces as "reset"). */
  displayStatus: z.string(),
  /** First order name, or "Unknown". */
  orderName: z.string(),
  /** Customer display name, or "Unknown Customer". */
  customerName: z.string(),
  /** Comma-joined product titles, or "No products". */
  productTitles: z.string(),
  /** Raw return status, shown verbatim on the actions sheet. */
  status: z.string(),
  /** Whether the Process action is available. */
  canProcess: z.boolean(),
  /** Whether the Reset action is available. */
  canReset: z.boolean(),
  /** Why Process is disabled, when it is. */
  processDisabledReason: z.string().optional(),
  /** Why Reset is disabled, when it is. */
  resetDisabledReason: z.string().optional(),
  /** Product ids to submit when processing the return. */
  productIds: z.array(z.string()),
});

const getPosManageReturnsViewInput = z.object({ search: z.string() });

const getPosManageReturnsViewOutput = z.object({
  items: z.array(posManageReturnsViewItemSchema),
});

export type PosManageReturnsViewItem = z.infer<
  typeof posManageReturnsViewItemSchema
>;
export type PosManageReturnsView = z.infer<
  typeof getPosManageReturnsViewOutput
>;

export const getPosManageReturnsView: {
  input: typeof getPosManageReturnsViewInput;
  output: typeof getPosManageReturnsViewOutput;
  name: "getPosManageReturnsView";
} = {
  name: "getPosManageReturnsView" as const,
  input: getPosManageReturnsViewInput,
  output: getPosManageReturnsViewOutput,
};
